import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eab84316"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice" }, [
  /*#__PURE__*/_createTextVNode(" 캠페인 문의는"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 카카오톡 채널 [원더플 캠페인] 을 검색해주세요. ")
], -1))
const _hoisted_3 = { class: "brands" }
const _hoisted_4 = { class: "brand-container" }
const _hoisted_5 = ["src"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const logos = [
  {
    img: require('./logo-1.png'),
  },
  {
    img: require('./logo-2.png'),
  },
  {
    img: require('./logo-3.png'),
  },
  {
    img: require('./logo-4.png'),
  },
  {
    img: require('./logo-5.png'),
  },
  {
    img: require('./logo-6.png'),
  },
  {
    img: require('./logo-7.png'),
  },
  {
    img: require('./logo-8.png'),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(logos, (item, index) => {
          return _createElementVNode("a", { key: index }, [
            _createElementVNode("img", {
              src: item.img
            }, null, 8, _hoisted_5)
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})